<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Bloqueo de Días</div>
      <div slot="sub-title">Administrar feriados legales</div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns">
        <div class="column">
          <card-component title="Tabla de Días Bloqueados" :subtitle="subtitle" class="has-table has-mobile-sort-spaced">
            <div slot="headerRight" class="card-header-icon buttons">
              <b-button type="is-link" class="is-pulled-right" icon-right="plus" @click="isCreateModalActive = true">
                Agregar
              </b-button>
            </div>
            <off-days-table slot="content" :data="OffDaysData" @edit="openFormEdit" @deleted="getOffDays" :is-loading="isLoadingTable"/>
          </card-component>
        </div>
        <div class="column is-narrow">
          <card-component title="Calendario" class="has-table has-mobile-sort-spaced" :header-search-input="false">
            <b-datepicker
              slot="content"
                inline
                v-model="date"
                :events="events"
                :indicators="indicators"
                :first-day-of-week="1"
                :month-names="$moment.months()"
                :day-names="$moment.weekdaysShort()"
                :unselectable-days-of-week="[0]"
                @input="isCreateModalActive = true"
                >
                <button class="button is-primary"
                    @click="date = new Date()">
                    <b-icon icon="calendar-today"></b-icon>
                    <span>Hoy</span>
                </button>
            </b-datepicker>
          </card-component>
        </div>
      </div>
    </section>
    <form-modal :active.sync="isCreateModalActive" @saved="getOffDays" :default-date="date" :off-day.sync="offDaySelected"/>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import CardComponent from '@/components/CardComponent'
import OffDaysTable from './components/OffDaysTable'
import FormModal from './components/FormModal'
import OffDayService from '@/services/OffDayService'

export default {
  name: 'home',
  components: {
    HeroBar,
    CardComponent,
    OffDaysTable,
    FormModal
  },
  created () {
    this.getOffDays()
  },
  data () {
    return {
      date: new Date(),
      events: [],
      isCreateModalActive: false,
      indicators: 'bars',
      startWeekDay: null,
      finishWeekDay: null,
      horses: [],
      dates: [],
      OffDaysData: [],
      offDaySelected: null,
      isLoadingTable: false
    }
  },
  methods: {
    openFormEdit (data) {
      this.offDaySelected = data
      this.isCreateModalActive = true
    },
    async getOffDays () {
      this.isLoadingTable = true
      let params = {
        'include[0]': 'type',
        'year': this.$moment().year()
      }
      let response = await OffDayService.getOffDays(params)
      this.OffDaysData = response.data.data.filter((x) => (x.type && x.type.code !== 'dominical') || !x.type)
      this.events = this.OffDaysData.map((offDay) => {
        let date = this.$moment(offDay.date, 'YYYY-MM-DD').toDate()
        return {
          date: date,
          type: 'is-danger'
        }
      })
      this.isLoadingTable = false
    }
  },
  computed: {
    subtitle () {
      let dataLenght = this.OffDaysData.length
      let plural = dataLenght === 1 ? '' : 's'
      return `${dataLenght} día${plural} bloqueado${plural}`
    }
  }
}
</script>
